'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "TooltipContainer": "Polaris-Tooltip__TooltipContainer",
  "HasUnderline": "Polaris-Tooltip__HasUnderline"
};

exports.default = styles;
